import React, { Component } from 'react';
import handleClickOutside from 'react-onclickoutside';
import * as PropTypes from 'prop-types';

@handleClickOutside
class AutoCompleteRenderer extends Component {
  handleClickOutside = this.props.handleClickOutside;

  renderAutocomplete = () => {
    const { loading, renderLoading, renderOptions } = this.props;
    return (
      <div className="autocomplete-wrapper">
        <div className="Select-menu-outer">{loading ? renderLoading() : renderOptions()}</div>
      </div>
    );
  };

  render() {
    return this.renderAutocomplete();
  }
}

AutoCompleteRenderer.propTypes = {
  handleClickOutside: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  renderLoading: PropTypes.func,
  renderOptions: PropTypes.func,
};

export default AutoCompleteRenderer;
